export default __webpack_public_path__ + "static/media/v2g.3e1475ab.svg";